import { Star, Quote, PlayCircle } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function StoryCard({ story, index = 0 }) {
  const { t, lang } = useLang();
  return (
    <div className="rounded-2xl bg-white border border-border shadow-sm overflow-hidden flex flex-col animate-fade-up" style={{ animationDelay: `${index * 70}ms` }} data-testid={`story-card-${story.id}`}>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex gap-0.5 mb-3">{Array.from({ length: story.rating || 5 }).map((_, j) => <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" />)}</div>
        <Quote className="w-7 h-7 text-primary/20" />
        <p className="text-base text-foreground/90 leading-relaxed mt-2 flex-1">"{lang === "es" && story.quote_es ? story.quote_es : story.quote}"</p>
        {story.video_url && (
          <a href={story.video_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary mt-4 hover:underline" data-testid={`story-video-${story.id}`}>
            <PlayCircle className="w-4 h-4" /> {t("stories.watchVideo")}
          </a>
        )}
        <div className="mt-4 pt-4 border-t border-border">
          <p className="font-semibold text-sm">{story.name}</p>
          <p className="text-xs text-muted-foreground">{[story.location, story.procedure].filter(Boolean).join(" · ")}</p>
          {story.clinic_name && <p className="text-xs text-primary mt-0.5">{story.clinic_name}</p>}
        </div>
      </div>
    </div>
  );
}
